import { getStore } from "app/store/store"
import { IAudience } from "audience/model"
import { ICampaignCreateParams, ICampaignUpdateParams } from "campaign/model"

export function getAudienceNameFromId(audienceId: number): string {
  const audience = getStore().getState().audience.audiences.find(a => a.id === audienceId)
  return audience ? audience.name : ""
}

export function getAllAudiencesInStore(): IAudience[] {
  return getStore().getState().audience.audiences
}

export function setAudienceDefaultParams(params: ICampaignCreateParams | ICampaignUpdateParams): void {
  if (!params) {
    return
  }
  params.dooh_audience_age = 3 * 60 // in seconds
  params.dooh_audience_radius = 250 // in meters
  params.dooh_audience_ratio = 1
}
